import { CompanyDocumentsType } from '@src/utilities/types';

export const getCompanyDocs = (registration: any, ibanData: any) => {
    const isCurrentDataValid = Object.values(registration.company.results.current).some(value => value && Number(value) > 0);
    const isPreviousDataValid = Object.values(registration.company.results.previous).some(value => value && Number(value) > 0);

    return [
        ...(ibanData?.code !== 200 ? [{
            id: '',
            filename: '',
            status: '',
            size: null,
            frontKey: 'bankAccountDetail',
            type: 'iban',
            type_detail: 'iban',
            title: 'RIB de la société',
        }] : []),
        {
            id: '',
            filename: '',
            status: '',
            size: null,
            frontKey: 'status',
            type: 'status-acts',
            type_detail: 'constitutive-statutes',
            title: "Statuts à jour certifiés conforme à l'original",
        },
        {
            id: '',
            filename: '',
            status: '',
            size: null,
            frontKey: 'kbis',
            type: 'status-acts',
            type_detail: 'kbis',
            title: 'Kbis de la société',
        },
        ...(isCurrentDataValid ? [{
            id: '',
            filename: '',
            status: '',
            size: null,
            frontKey: 'financialStatements',
            type: 'status-acts',
            type_detail: 'tax-package',
            title: 'Liasse fiscale'
        }] : []),
        ...(isPreviousDataValid ? [{
            id: '',
            filename: '',
            status: '',
            size: null,
            frontKey: 'financialStatementsN-1',
            type: 'status-acts',
            type_detail: 'tax-package',
            title: 'Liasse fiscale'
        }] : []),
        {
            id: '',
            filename: '',
            status: '',
            size: null,
            frontKey: 'beneficiariesRegister',
            type: 'status-acts',
            type_detail: 'register-be',
            title: 'Copie du registre des bénéficiaires effectifs',
        },
        {
            id: '',
            filename: '',
            status: '',
            size: null,
            frontKey: 'lei',
            type: 'status-acts',
            type_detail: 'lei-proof',
            title: 'Justificatif LEI',
        },
        {
            id: '',
            filename: '',
            status: '',
            size: null,
            frontKey: 'collectiveDecision',
            type: 'status-acts',
            type_detail: 'decision-authorize-open-account',
            title: "Décision collective des associés autorisant l'ouverture de compte (si société civile)",
        },
        {
            id: '',
            filename: '',
            status: '',
            size: null,
            frontKey: 'formW8BENE',
            type: 'tax-proof',
            type_detail: 'form-w8',
            title: 'Formulaire W-8BEN-E en anglais',
        },
        {
            id: '',
            filename: '',
            status: '',
            size: null,
            frontKey: 'authorizedSignatures',
            type: 'contractual-document',
            type_detail: 'list-of-authorizations',
            title: 'Liste des signatures autorisées et pouvoirs',
        },
        {
            id: '',
            filename: '',
            status: '',
            size: null,
            frontKey: 'listOfAssociates',
            type: 'correspondence',
            type_detail: 'others',
            title: 'Liste à jour des associés',
        },
        ...(registration.company.srd_ror.access ? [{
            id: '',
            filename: '',
            status: '',
            size: null,
            frontKey: 'srdDocument',
            type: 'link-sheet',
            type_detail: 'srd-expertise',
            title: 'Demande SRD',
        }] : []),
    ] as CompanyDocumentsType[];
};
